<template>
<div>
  <div class="centre">
    <h2>Our collaborators</h2>
    <div class="cooperation">
    <div class="picture">
      <div class="mit">
        <img src="@/assets/mit.png"  width="100%" height="100%">
      </div>
      <p class="text" >MIT</p>
    </div>
      <div class="picture">
        <div class="white">
          <img src="@/assets/harmonize.png"  width="100%" height="100%">
        </div>
        <p>Peking Union Medical College Hospital</p>
      </div>
      <div class="picture">
          <div class="white">
              <img src="@/assets/anzhen.png"  width="100%" height="100%">
          </div>
          <p>Anzhen<br /> Hospital</p>
      </div>
      <div class="picture">
          <div class="white">
              <img src="@/assets/fuwai.png"  width="100%" height="100%">
          </div>
          <p>Fuwai<br /> Hospital</p>
      </div>
      <div class="picture">
        <div class="white">
          <img src="@/assets/Stanford.png"  width="100%" height="100%">
        </div>
        <p>Stanford<br /> University</p>

      </div>
      <div class="picture">
        <div class="white">
          <img src="@/assets/jd-university.png" width="100%" height="100%">
        </div>
        <p>Shanghai Jiao<br/> Tong University</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "cooperation.vue"
}
</script>

<style scoped>

.centre {
  width: 1200px;
  margin: 100px auto;
  background: #F0F3F5;
  border-radius: 12px;
  padding:60px 80px;
  box-sizing:border-box;
}

.centre h2 {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 60px;
}

.centre  .cooperation {
  display: flex;
  justify-content: space-between;
}

.centre .picture {
  height: 200px;
  width: 160px;
  background-color: #FFFFFF;
  border-radius: 10px;
}

.centre .picture .white {
  margin-top: 25px;
  margin-left: 40px;
  width: 80px;
  height: 80px;
  text-align: center;
  background-color: #FFFFFF;
}

.centre .picture .mit {
  margin-top: 43px;
  margin-left: 38px;
  width: 84px;
  height: 50px;
  text-align: center;
}

.centre .picture p {
  margin-top: 11px;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.centre .picture .text {
  margin-top: 26px;
}


</style>
